export const colorType =[
    ['#6FA8DC','#FFFFFF'],
    ['#FFD966','#FFFFFF'],
    ['#666666','#FFFFFF'],
    ['#E06666','#FFFFFF'],
    ['#6FA8DC','#FFFFFF'],
]